import { render, staticRenderFns } from "./groupNoAdv.vue?vue&type=template&id=2f7df06a&scoped=true"
import script from "./groupNoAdv.vue?vue&type=script&lang=js"
export * from "./groupNoAdv.vue?vue&type=script&lang=js"
import style0 from "./groupNoAdv.vue?vue&type=style&index=0&id=2f7df06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7df06a",
  null
  
)

export default component.exports